import EmailPreview from './EmailPreview';

export default EmailPreview;
